import { render, staticRenderFns } from "./icon-settings.vue?vue&type=template&id=5eeafa71"
import script from "./icon-settings.vue?vue&type=script&lang=ts"
export * from "./icon-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports